// extracted by mini-css-extract-plugin
export default {"list":"SummaryList_list__4QDs1","active":"SummaryList_active__gr9Jy","inactive":"SummaryList_inactive__coGg-"};